// src/components/homepage/Hero.jsx
import { Link } from "react-router-dom";
import HeroImage from "../../assets/main_page/train_like_a_high_performer.jpg";

export default function Hero({ title, subtitle, cta }) {
  return (
    <section className="relative w-full py-10 px-6 overflow-hidden">
      {/* Background Aura */}
      <div className="absolute -top-24 left-0 w-96 h-96 bg-neonTurquoise/10 blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-purple-500/10 blur-[180px] rounded-full"></div>

      <div className="relative flex justify-center items-center">
        <div
          className="flex flex-col md:flex-row items-center gap-10 max-w-6xl w-full 
          bg-white/5 backdrop-blur-xl rounded-3xl border border-white/10
          shadow-[0_0_50px_rgba(0,0,0,0.4)] p-8 md:p-14"
        >
          {/* LEFT COLUMN — TEXT */}
          <div className="md:w-1/2 flex flex-col justify-center text-center md:text-left space-y-5">
            <h1 className="text-white text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight drop-shadow-lg">
              {title}
            </h1>

            <p className="text-neonTurquoise text-lg sm:text-xl md:text-2xl font-semibold drop-shadow-md">
              {subtitle}
            </p>

            <p className="text-grayText text-base sm:text-lg md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
              Through a combination of endurance, strength, sport-specific
              performance, and nutrition strategies, I help clients achieve
              sustainable results and elevate their performance in all aspects
              of life. Join me to build resilience, power, and longevity while
              reaching your personal fitness goals.
            </p>

            <Link to="/contact" className="pt-2 self-center md:self-start">
              <button
                className="bg-neonTurquoise text-black font-bold py-3 px-8 rounded-xl 
                hover:brightness-110 hover:shadow-[0_0_18px_rgba(0,255,255,0.6)]
                transition-all duration-300"
              >
                {cta}
              </button>
            </Link>
          </div>

          {/* RIGHT COLUMN — IMAGE */}
          <div className="md:w-1/2 relative flex justify-center md:justify-end">
            {/* Decorative Borders */}
            <div className="absolute -top-5 -left-5 w-full h-full rounded-3xl border-2 border-neonTurquoise/20 rotate-1"></div>
            <div className="absolute -bottom-5 -right-5 w-full h-full rounded-3xl border-2 border-purple-500/20 -rotate-1"></div>

            {/* Image Container */}
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={HeroImage}
                alt="Kalon Pillars"
                className="w-full max-w-xs sm:max-w-sm md:max-w-md h-auto object-cover 
                  transition-transform duration-500 hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
